import { createVanIconComponent } from "./van"

const Ascending = createVanIconComponent("ascending")
export default Ascending
